import React from 'react';
import { Provider } from 'react-redux';
import { configureStore as store, persistor } from '../redux/store';
import { PersistGate } from 'redux-persist/integration/react';

const App: React.FC = ({ children }: any) => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      {children}
    </PersistGate>
  </Provider>
);

App.displayName = 'SWXApp';

export default App;
